import { render, staticRenderFns } from "./Mcoach.vue?vue&type=template&id=ade94cd4&scoped=true"
import script from "./Mcoach.vue?vue&type=script&lang=js"
export * from "./Mcoach.vue?vue&type=script&lang=js"
import style0 from "./Mcoach.vue?vue&type=style&index=0&id=ade94cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade94cd4",
  null
  
)

export default component.exports